import downArrow from '@SvgIcon/ios-arrow-down.svg';
import rightArrow from '@SvgIcon/ios-arrow-right.svg';

import $ from 'jquery';
import swal from 'sweetalert2';
import Vue from 'vue';
import each from 'lodash/each';
import throttle from 'lodash/throttle';
import objectFitImages from 'object-fit-images';
import ViewportUnitsBuggyfill from 'viewport-units-buggyfill';

import 'autotrack/autotrack';
import 'bootstrap-datepicker';

import '../shared/hmr';

import { setupCarousels } from './_carousel';
import { setupModal } from './_modal';
import { setupPhotoGalleries } from './_photo-gallery';
import { setupVideos } from './_video';
import { setupParallax } from './_parallax';
import { warnOnOutboundLinks } from './_outbound-link';
import svgIconHtml from '../shared/svgIconHtml';

import './foundation';
import './vue';

import '../shared/address_autocompletion';
import '../shared/component/ProgressCircular';
import '../shared/component/Switch';
import '../shared/widget/char_counter';
import '../shared/widget/email';
import '../shared/widget/password';

import './component/PhotoGallery';
import './component/ScrollToTop';
import './component/SocialShare';
import './module/form/handleForms';
import './module/product/filters';
import './module/search/searchModal';

import '../../scss/shared/shared.scss';
import '../../scss/app/foundation.scss';
import '../../scss/app/app_vendor.scss';
import '../../scss/app/app.scss';

ViewportUnitsBuggyfill.init();
objectFitImages();

/**
 * IE 10 has buggy flex support, so we need to target it for some hacks
 */

document.documentElement.setAttribute('data-useragent', navigator.userAgent);

/**
 * iOS 7 has buggy vh unit support. ViewportUnitsBuggyfill takes care of unsupported units in linked stylesheets
 * but can not handle inline <style> elements. We'll detect bad iOS 7 and add a class to handle it manually.
 */

const isBadMobileSafari = /(iPhone|iPod|iPad).+AppleWebKit/i.test(window.navigator.userAgent) && (() => {
  const iOSversion = window.navigator.userAgent.match(/OS (\d+)/);
  // viewport units work fine in mobile Safari and webView on iOS 8+
  return iOSversion && iOSversion.length > 1 && parseInt(iOSversion[1]) < 10;
})();

if (isBadMobileSafari) {
  $('html').addClass('no-vh-support');
}

$(document).ajaxError((ev, xhr, settings) => {
  if ('errorHandled' in settings && settings.errorHandled) {
    return;
  }

  if (xhr.statusText === 'abort') {
    return;
  }

  switch (xhr.status) {
    case 0:
      swal('Error', 'Please check your internet connection.', 'error');
      return;
    case 404:
      swal('Error', 'The requested page was not found. [404]', 'error');
      return;
    case 500:
      swal('Error', 'Internal Server Error. [500]', 'error');
      return;
  }

  switch (xhr.statusText) {
    case 'parsererror':
      swal('Error', 'Requested JSON parse failure.', 'error');
      return;
    case 'timeout':
      swal('Error', 'Request timed out. Check your internet.', 'error');
      return;
    case 'error':
      swal('Error', xhr.statusText, 'error');
      return;
  }
});

const $body = $(document.body);

//
// Vue
//

each(document.querySelectorAll('.vue-mount'), el => new Vue({ el }));

//
// Enhance mobile header
//

const $mobilePageHeader = $('.page-header__mobile');
const $mobilePageHeaderLeft = $mobilePageHeader.find('.left');
const $mobilePageHeaderCenter = $mobilePageHeader.find('.center');
if (!$mobilePageHeaderLeft.children().length) {
  $mobilePageHeaderLeft.addClass('empty');
  $mobilePageHeaderCenter.addClass('adjust-left');
}

$('.js-mobile-nav-toggle').on('click', (ev) => {
  ev.preventDefault();
  $body.toggleClass('nav-open');
});

$('.mobile-nav .has-submenu').each((liIdx, li) => {
  $(li).children('a, span').each((anchorIdx, anchor) => {
    $(anchor)
      .wrapInner('<span class="caption"></span>')
      .append(`<button type="button" class="toggle-submenu">
        <span class="collapsed">${svgIconHtml(downArrow)}</span>
        <span class="expanded">${svgIconHtml(rightArrow)}</span>
      </button>`);
  });
});

$('.mobile-nav').on('click', '.toggle-submenu', (ev) => {
  ev.preventDefault();
  ev.stopPropagation();
  $(ev.currentTarget).closest('li').toggleClass('expanded');
});

//
//
//

const mediumMql = window.matchMedia(`screen and (min-width: ${window.APP.breakpoints.medium})`);

//
// Hide mobile footer when mobile keyboard appears
// This is a hackish implementation since there isn't a foolproof way to detect the keyboard yet.
//

const originalWinSize = $(window).width() + $(window).height();

function handleMediaQueryChangeKeyboard(mql) {
  const $window = $(window);
  if (mql.matches) {
    $window.off('resize.keyboard-watcher');
  } else {
    $window.on('resize.keyboard-watcher', () => {
      if ($(window).width() + $(window).height() < originalWinSize - 50) {
        $('body').addClass('has-visible-keyboard');
      } else {
        $('body').removeClass('has-visible-keyboard');
      }
    });
  }
}

mediumMql.addListener(handleMediaQueryChangeKeyboard);
handleMediaQueryChangeKeyboard(mediumMql);

//
// Date inputs
//

const $dateInputs = $('input[type="date"]');

function handleMediaQueryChangeForDateInputs(mql) {
  if (mql.matches) {
    $dateInputs.attr('type', 'text');
  } else {
    $dateInputs.attr('type', 'date');
  }
}

mediumMql.addListener(handleMediaQueryChangeForDateInputs);
handleMediaQueryChangeForDateInputs(mediumMql);

//
// "Other" radio/checkbox inputs
//

$(document).on('click', 'input.other-input', (ev) => {
  $(ev.currentTarget).closest('.form-check-label').children(':checkbox, :radio').prop('checked', 'checked');
});

//
// Modal triggers
//

$(document).on('click', 'a[href^="#modal-"]', (ev) => {
  ev.preventDefault();
  const $anchor = $(ev.currentTarget);
  const $modal = $($anchor.attr('href'));
  const modal = setupModal($modal);
  if (modal) {
    modal.open();
  }
});

//
// Hook into anchors to compensate for the fixed header
//

(function watchAnchors(document, history, location) {
  const HISTORY_SUPPORT = !!(history && history.pushState);

  const anchorScrolls = {
    ANCHOR_REGEX: /^#[^ ]+$/,

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init() {
      setTimeout(() => {
        this.scrollToCurrent();
      }, 100);
      window.addEventListener('hashchange', this.scrollToCurrent.bind(this));
      document.body.addEventListener('click', this.delegateAnchors.bind(this));
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset() {
      return $('.page-header').height() + 50;
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @param  {Boolean} pushToHistory
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor(href, pushToHistory) {
      if (!this.ANCHOR_REGEX.test(href)) {
        return false;
      }

      const match = document.getElementById(href.slice(1));

      if (match) {
        const rect = match.getBoundingClientRect();
        const anchorOffset = (window.pageYOffset + rect.top) - this.getFixedOffset();
        window.scrollTo(window.pageXOffset, anchorOffset);

        // Add the state to history as-per normal anchor links
        if (HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href);
        }
      }

      return !!match;
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent() {
      this.scrollIfAnchor(window.location.hash, false);
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors(ev) {
      if (
        ev.target.nodeName === 'A' && !$(ev.target).data() &&
        this.scrollIfAnchor(ev.target.getAttribute('href'), true)
      ) {
        ev.preventDefault();
      }
    },
  };

  const init = () => {
    anchorScrolls.init.bind(anchorScrolls)();
  };

  if (module.hot) {
    $(window).on('load', init);
  } else {
    $(document).ready(init);
  }
}(window.document, window.history, window.location));

//
// Custom reveal
//

$('.custom.reveal').on('click', '.overlay', (ev) => {
  $(ev.currentTarget).closest('.reveal').foundation('close');
});

//
// Videos
//

setupVideos(document.body);

//
// Carousels
//

setupCarousels(document.body);

//
// Photo Galleries
//

setupPhotoGalleries(document.body);

//
// Parallax
//

setupParallax(document.body);

//
// Outbound links
//

if (window.APP.context.outbound_link_warning.display) {
  warnOnOutboundLinks();
}

//
// Header resize
//

const $headerEl = $('.page-header');

function resizeHeader() {
  if (window.pageYOffset > 200) {
    $headerEl.addClass('smaller');
  } else {
    $headerEl.removeClass('smaller');
  }
}

resizeHeader();
$(window).on('scroll', throttle(resizeHeader, 100));
